import CaptchaTypeTableDto from 'app/admin/captchatype/dto/CaptchaTypeTableDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';

class CaptchaTypeTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'captchaTypeTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<CaptchaTypeTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, CaptchaTypeTableDto)))
				.catch(reject);
		});
	}
}

export default new CaptchaTypeTableService();
